import { connect } from 'react-redux'
import get from 'lodash/get'
import Loader from '../../components/loader/loader'

const mapStateToProps = (state, ownProps) => {

  if (!ownProps.resource) return { loading: false }

  const { finishedLoading = false } = get(state, ownProps.resource, {})

  return {
    loading: !finishedLoading
  }
}

const mapDispatchToProps = (dispatch) => {
  return {}
}

export default connect(mapStateToProps, mapDispatchToProps)(Loader)



// WEBPACK FOOTER //
// ./src/containers/loader/loader-container.js